<template>
    <div class="wallet-header">
        <div class="wallet-title">
            <div :class="['wallet-back', { active: (type === 1 && route.query.back) || type === 2 }]" @click="handleBack"></div>
            <div class="wallet-txt">{{ $t(title) }}</div>
            <div class="wallet-sevice"></div>
        </div>
        <div class="wallet-select" @click="handleChangeCurrency">
            <div class="select-pic"><img :src="currency.picture" /></div>
            <div class="select-cur">{{ currency.currency }}({{ currency.clientcurrency }})</div>
            <div class="select-icon"></div>
        </div>
        <div class="wallet-money">
            <div class="money-count">{{ formatLocalMoney(wallet?.gold || 0) }}</div>
            <div v-if="type === 1" class="withdraw-icon" @click="goWithdraw">{{ $t('Withdrawal') }}</div>
        </div>
        <div class="wallet-other">
            <div class="other-left">
                <span class="other-help" @click="showTip = true"></span>
                <!-- <template v-if="type === 1"> -->
                <span class="other-title bonus">Bonus</span>
                <span class="other-count">{{ currency.clientcurrency }}{{ formatNormalNumber(wallet?.bonus || 0) }}</span>
                <!-- </template> -->
                <!-- <template v-else>
                    <span class="other-title">{{ $t('Available_withdrawal') }}:</span>
                    <span class="other-count">{{ needFormat ? formatNumber(balance || 0) : formatNormalNumber(balance || 0) }}</span>
                </template> -->
            </div>
            <div></div>
            <div class="wallet-record" @click="handleRecoder">{{ $t('Record') }}</div>
        </div>
        <Record v-if="recordVisible" v-model="recordVisible" :type="type" />
        <Currency v-model="showCurrency" @confirm="onSelect" @getData="getCurrencyConf" :default="wallet.currency" />
        <!-- <van-overlay :show="showTip" :lock-scroll="false" @click="showTip = false" z-index="3001">
            <div class="dialog" @click.stop>
                <div class="title">
                    {{ type === 1 ? 'Bonus' : $t('Available_withdrawal') }}
                    <div class="close" @click="showTip = false"></div>
                </div>
                <div
                    class="content"
                    v-html="
                        $t(
                            type === 1 ? 'bonus_explanation' : `Withdrawal_balance_info_${currency.currency}`,
                            type === 1
                                ? {
                                      level: vipInfo.curLevel,
                                      betrebate: betRebate,
                                  }
                                : {}
                        )
                    "
                ></div>
                <div class="confirm" @click="showTip = false">{{ $t('Confirm') }}</div>
            </div>
        </van-overlay> -->
        <Tip
            v-model="showTip"
            title="Bonus"
            :content="
                $t('bonus_explanation', {
                    level: vipInfo.curLevel,
                    betrebate: betRebate * 100 + '%',
                })
            "
        />
    </div>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import { storeToRefs } from 'pinia'
import Currency from '@/components/wallet/currencyDialog.vue'
import Record from '@/components/wallet/record.vue'
import { useRouter, useRoute } from 'vue-router'
import { formatLocalMoney, formatNormalNumber } from '@/utils/toolsValidate'
import { Log } from '@/api/log'
import Tip from './tip.vue'

import { useGame } from '@/hooks/useGame'
// import { onBeforeRouteLeave } from 'vue-router'

const props = defineProps({
    type: {
        type: Number,
        default: () => 1,
    },
    title: {
        type: String,
        default: '',
    },
    balance: {
        type: Number,
        default: () => 0,
    },
})
const emits = defineEmits(['getData'])

const { gameSubscibe } = useGame()
const router = useRouter()
const route = useRoute()
const store = useBaseStore()
const { wallet, currencyList, vipInfo, vipConfig } = storeToRefs(store)
const showCurrency = ref(false)
const recordVisible = ref(false)
const showTip = ref(false)

const currency = computed(() => {
    return currencyList.value.find((item) => item.currency === wallet.value?.currency) || currencyList.value[0]
})
const betRebate = computed(() => {
    return vipConfig.value.find((item) => item.level === vipInfo.value.curLevel)?.betRebate || 0
})
const onSelect = (item) => {
    wallet.value.currency = item.currency
}
const handleBack = async () => {
    if (route.query.from === 'game') {
        const url = await gameSubscibe(store.prevGameTag)
        router.replace({
            path: '/iframe',
            query: {
                u: encodeURIComponent(url),
                from: 'wallet',
            },
        })
    } else {
        router.back()
    }
}

const getCurrencyConf = (confs) => {
    emits('getData', confs)
}
const goWithdraw = () => {
    Log({ event: 'wallet_withdraw' })
    router.push({
        path: '/cashout',
    })
}
const handleRecoder = () => {
    Log({ event: props.type === 1 ? 'wallet_deposit_record' : 'wallet_withdraw_record' })
    recordVisible.value = true
}
const handleChangeCurrency = () => {
    Log({ event: 'wallet_exch_currency' })
    showCurrency.value = true
}
</script>
<style lang="scss" scoped>
.wallet-header {
    padding: 86px 30px 0;
    height: 450px;
    background: url('@/assets/img/wallets/bg.jpg') no-repeat left bottom;
    background-size: 100% 450px;
    border-radius: 0px 0px 40px 40px;

    font-family: MicrosoftYaHei;

    .wallet-title {
        display: flex;
        margin-bottom: 35px;

        .wallet-txt {
            flex: 1;
            line-height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 36px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
        }

        .wallet-back,
        .wallet-sevice {
            width: 40px;
            height: 40px;
        }
        // .wallet-sevice {
        //     background: url('@/assets/img/wallets/customer.png') no-repeat;
        //     background-size: 100% 100%;
        // }
        .wallet-back {
            opacity: 0;
            pointer-events: none;
            background: url('@/assets/img/wallets/back.png') no-repeat;
            background-size: 22px 100%;
            &.active {
                opacity: 1;
                pointer-events: all;
            }
        }
    }
    .wallet-select {
        display: flex;
        align-items: center;
        width: 189px;
        height: 44px;
        padding: 0 3px;
        border-radius: 50px;
        background: rgba(255, 255, 255, 0.35);
        // border: solid 4px #ffffff;
        font-family: MicrosoftYaHei;
        font-size: 28px;
        line-height: 50px;
        color: #ffffff;

        .select-pic {
            width: 37px;
            height: 37px;
            border-radius: 50%;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .select-cur {
            flex: 1;
            margin: 0 8px;
        }
        .select-icon {
            width: 37px;
            height: 37px;
            background: url('@/assets/img/wallets/slect_icon.png') no-repeat left bottom;
            background-size: 100% 100%;
        }
    }

    .wallet-money {
        display: flex;
        align-items: center;
        position: relative;
        // margin-top: 20px;
        padding: 20px 0;

        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -2px;
            width: 680px;
            height: 4px;
            background-color: #ffffff;
            border-radius: 2px;
            opacity: 0.4;
        }

        .money-count {
            flex: 1;
            font-size: 48px;
            color: #ffea76;
            line-height: 48px;
        }
        .withdraw-icon {
            display: flex;
            align-items: center;
            padding: 8px 20px 0 26px;
            min-width: 262px;
            height: 59px;
            border-radius: 50px;
            background: var(--Linear, linear-gradient(90deg, #fffc7f 0%, #ffdc6d 100%));
            color: #2a2d3d;

            text-align: center;
            font-family: 'Microsoft YaHei';
            font-size: 36px;
            font-weight: 600;

            &::before {
                display: inline-block;
                content: '';
                margin-right: 9px;
                width: 46px;
                height: 37px;
                background: url('@/assets/img/wallets/withdraw_icon.png') no-repeat left bottom;
                background-size: 100% 100%;
            }
        }
    }
    .wallet-other {
        padding-top: 20px;
        display: flex;
        align-items: center;

        .other-left {
            display: flex;
            align-items: center;
            flex: 1;

            .other-help {
                display: inline-block;
                margin-right: 8px;
                width: 30px;
                height: 30px;
                background: url('@/assets/img/wallets/qestion_icon.png') no-repeat;
                background-size: 100% 100%;
            }
            .other-title {
                position: relative;
                font-size: 30px;
                color: #ffffff;
                // &.bonus {
                //     @apply flex items-center;
                //     &::before {
                //         display: inline-block;
                //         content: '';
                //         margin-right: 11px;
                //         width: 30px;
                //         height: 30px;
                //         background: url('@/assets/img/wallets/B.png') no-repeat;
                //         background-size: 100% 100%;
                //     }
                // }
            }
            .other-count {
                margin-left: 20px;
                font-size: 36px;
                line-height: 30px;
                color: #ffea76;
            }
        }
        .wallet-record {
            position: relative;
            // width: 30px;
            // height: 30px;
            font-size: 30px;
            // line-height: 30px;
            color: #ffffff;

            &::before,
            &::after {
                display: inline-block;
                content: '';
            }
            &::before {
                position: absolute;
                left: 0;
                bottom: -3px;
                width: 100%;
                height: 4px;
                background-color: #ffffff;
                border-radius: 2px;
            }
            &::after {
                position: relative;
                top: 5px;
                margin-left: 10px;
                width: 30px;
                height: 30px;
                background: url('@/assets/img/wallets/enter-arrow.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
// .dialog {
//     @apply flex flex-col;
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     width: 660px;
//     height: 840px;
//     padding: 0 28px 60px;
//     border-radius: 40px;
//     background-color: #2a2d3d;
//     font-family: MicrosoftYaHei;
//     color: #ffffff;

//     transform: translate3d(-50%, -60%, 0);

//     .title {
//         position: relative;
//         margin-bottom: 29px;
//         line-height: 99px;
//         font-size: 40px;
//         text-align: center;

//         &::after {
//             content: '';
//             position: absolute;
//             left: 50%;
//             bottom: 0;
//             width: 620px;
//             height: 4px;
//             background-color: #ffffff;
//             border-radius: 2px;
//             opacity: 0.2;

//             transform: translateX(-50%);
//         }
//         .close {
//             position: absolute;
//             top: 30px;
//             right: 20px;
//             width: 33px;
//             height: 34px;
//             background: url('@/assets/img/new-home/close.png') no-repeat;
//             background-size: 100% 100%;
//         }
//     }
//     .content {
//         flex: 1;
//         overflow-y: scroll;
//         font-size: 30px;
//         font-weight: normal;
//         font-stretch: normal;
//         line-height: 60px;
//         letter-spacing: -1px;

//         // :deep(span) {
//         //     display: block;
//         //     margin-bottom: 60px;
//         // }
//     }
//     .confirm {
//         margin: 20px auto 0;
//         width: 440px;
//         height: 88px;
//         line-height: 88px;
//         background-image: linear-gradient(90deg, #10c57f 0%, #0e8e66 100%), linear-gradient(#e59e20, #e59e20);
//         background-blend-mode: normal, normal;
//         border-radius: 44px;
//         text-align: center;
//         font-size: 36px;
//         color: #ffffff;
//     }
// }
</style>
